export const environment = {
	production: true,

	apiBaseUrl: 'https://qa13.unitas.repolog.api.vergentlms.com/',
	appBaseUrl: 'https://qa13.unitas.repolog.vergentlms.com',
	LegacyVergentBaseUrl: 'https://qa13-unitas.vergentlms.com',

	// ACV Settings
	TMX_ACVEnabled: false,
	TMX_ACVRootUrl: 'http://ecashqacoreacv.titlemax.biz:8080/ACVApp',
	TMX_ESignUrl:
		'https://ecashpaperless-qa.titlemax.com/esign-service-web-ecash/#/session/list?',
	TMX_VirtualStoreRootUrl: 'http://ecashqatlxmicrosvc03.titlemax.biz:8099',
	eCash_AcvUIUrl: 'https://qa13-acv.vergentlms.com/ui',

	// TLXe Settings
	tlxeBaseUrl: 'https://qa13-unitas.vergentlms.com',
	acvBaseUrl: 'https://qa13-acv.vergentlms.com/ui/acv/',
};
